export const RootAPI = "https://admin-checkin.minhkhuonggroup.vn/api/";
